import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getPatientInsuranceProfiles } from 'api/InsuranceProfiles';

export const useInsuranceProfiles = ({ params, options }) => {
  const navigate = useNavigate();
  const { userId, practitionerId, resolveNetworkStatus } = params;

  return useQuery(
    ['insurance-profiles', userId, practitionerId, resolveNetworkStatus],
    ({ signal }) => getPatientInsuranceProfiles(navigate, params, signal),
    {
      enabled: !!userId,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      ...options
    }
  );
};
